export default __webpack_public_path__ + "static/upload-4162a6f12631bf23b985611b70062e92.gif";